import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { useCorporateFieldsContext } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/hooks/useCorporateFieldsContext';

export interface MarketSelectProps {
  name: string;
  id: string;
}

export function MarketSelect({ name, id }: MarketSelectProps): JSX.Element {
  const { control, errors } = useFormContext();
  const { corpFieldsData } = useCorporateFieldsContext();
  const marketOptions = corpFieldsData?.markets || [];

  return (
    marketOptions && (
      <CookbookSelectWrapper
        label="Market"
        name={name}
        id={id}
        options={marketOptions}
        error={errors[name]}
        control={control}
        blockWidth
      />
    )
  );
}
